import { render, staticRenderFns } from "./SurfaceNavEmbedActions.vue?vue&type=template&id=163852d9&"
import script from "./SurfaceNavEmbedActions.vue?vue&type=script&lang=js&"
export * from "./SurfaceNavEmbedActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports